'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fullscreenVideo = require('./fullscreenVideo.js');

var _fullscreenVideo2 = _interopRequireDefault(_fullscreenVideo);

var _fullscreenImage = require('./fullscreenImage.js');

var _fullscreenImage2 = _interopRequireDefault(_fullscreenImage);

var _fullscreenText = require('./fullscreenText.js');

var _fullscreenText2 = _interopRequireDefault(_fullscreenText);

var _utils = require('../utils');

var _fullscreenStoreBottomMobileBar = require('./fullscreenStoreBottomMobileBar.js');

var _fullscreenStoreBottomMobileBar2 = _interopRequireDefault(_fullscreenStoreBottomMobileBar);

var _fullscreen = require('@wix/photography-client-lib/dist/src/versioning/features/fullscreen');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullscreenSlider = function (_React$Component) {
  (0, _inherits3.default)(FullscreenSlider, _React$Component);

  function FullscreenSlider(props) {
    (0, _classCallCheck3.default)(this, FullscreenSlider);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FullscreenSlider.__proto__ || (0, _getPrototypeOf2.default)(FullscreenSlider)).call(this, props));

    _this.marginWidth = 0;
    return _this;
  }

  (0, _createClass3.default)(FullscreenSlider, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (_fullscreen.fullscreenVersionManager.useFullscreenNewSlider() && !_utils.utils.isSmallScreen()) {
        if (this.dummyAccessibilityItem) {
          this.dummyAccessibilityItem.focus();
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (_fullscreen.fullscreenVersionManager.useFullscreenNewSlider() && !_utils.utils.isSmallScreen()) {
        if (prevProps.current.idx !== this.props.current.idx) {
          if (this.props.current.idx <= 0) {
            this.rightArrowElement && this.rightArrowElement.focus();
          } else if (this.props.current.idx >= this.props.totalItems - 1) {
            this.leftArrowElement && this.leftArrowElement.focus();
          }
        } else if (prevProps.window.expanded !== this.props.window.expanded && this.dummyAccessibilityItem) {
          this.dummyAccessibilityItem.focus();
        }
      }
    }
  }, {
    key: 'isInDisplayRange',
    value: function isInDisplayRange(idx) {
      if (this.props.styleParams.fullscreenLoop) {
        return true;
      } else {
        var range = _utils.utils.isTouch() ? 2 : 3;
        return Math.abs(this.props.current.idx - idx) <= range;
      }
    }
  }, {
    key: 'getSlideWidth',
    value: function getSlideWidth(addMargins) {
      return this.props.window.size.width + (_utils.utils.isMobile() && addMargins ? 2 * this.marginWidth : 0); //add space for margins
    }
  }, {
    key: 'prepareSlide',
    value: function prepareSlide(item) {
      var idx = item.idx;
      var inner = void 0;
      switch (item.type) {
        case 'video':
          inner = _react2.default.createElement(_fullscreenVideo2.default, {
            key: idx,
            item: item,
            isDisplayed: this.props.current.idx === idx,
            currentIdx: this.props.current.idx,
            isDummy: !this.isInDisplayRange(idx),
            window: this.props.window,
            styleParams: this.props.styleParams,
            actions: {
              toggleMobileBars: this.props.actions.toggleMobileBars
            }
          });
          break;
        case 'text':
          inner = _react2.default.createElement(_fullscreenText2.default, {
            key: idx,
            item: item,
            isZoom: this.props.isMobileZoom,
            isDummy: !this.isInDisplayRange(idx),
            window: this.props.window
          });
          break;
        case 'image':
        case 'picture':
        default:
          inner = _react2.default.createElement(_fullscreenImage2.default, {
            key: idx,
            item: item,
            isZoom: this.props.isMobileZoom,
            isDummy: !this.isInDisplayRange(idx),
            window: this.props.window,
            isMobile: _utils.utils.isMobile()
          });
      }
      return inner;
    }
  }, {
    key: 'prepareInfo',
    value: function prepareInfo(itm) {
      return _utils.utils.isMobile() && _fullscreen.fullscreenVersionManager.useFullscreenNewMobileLayout() ? _react2.default.createElement(_fullscreenStoreBottomMobileBar2.default, {
        current: this.props.current,
        item: itm,
        styleParams: this.props.styleParams,
        love: this.props.love
        // showInfo={this.props.showInfo}
        , actions: this.props.actions,
        showShopFrame: this.props.showShopFrame,
        showMobileShopFrame: this.props.showMobileShopFrame,
        showShareScreen: this.props.showShareScreen,
        galleryId: this.props.galleryInfo && this.props.galleryInfo.galleryId ? this.props.galleryInfo.galleryId : '',
        providerView: this.props.providerView,
        pricingData: this.props.pricingData,
        onAddToCartRequest: this.props.onAddToCartRequest,
        onProviderAction: this.props.onProviderAction,
        cartItemsCount: this.props.cartItemsCount
      }) : null;
    }
  }, {
    key: 'prepareSlides',
    value: function prepareSlides() {
      var slides = [];

      for (var i = 0; i < this.props.items.length; i++) {
        var isSwipeVersion = _utils.utils.isTouch();
        var animationType = isSwipeVersion ? 'swipe-' : 'fade-';

        var innerStyle = {
          width: this.getSlideWidth(false) + 'px'
        };

        var itm = this.props.items[i];
        var slidePos = i;
        var isCurrent = false;
        var slideClasses = ['pro-fullscreen-slide'];

        switch (slidePos - this.props.current.pos) {
          case 0:
            slideClasses.push(animationType + 'current current-slide fullscreen-current');
            isCurrent = true;
            break;
          case 1:
            slideClasses.push(animationType + 'adjacent next-slide');
            break;
          case -1:
            slideClasses.push(animationType + 'adjacent prev-slide');
            break;
          default:
            slideClasses.push(animationType + 'far-away');
        }

        if (this.props.animating) {
          slideClasses.push(animationType + 'animated');

          switch (slidePos - this.props.current.pos) {
            case 0:
              slideClasses.push(animationType + 'animated-current');
              break;
            case 1:
              if (this.props.direction === 1) {
                slideClasses.push(animationType + 'animated-next');
              }
              break;
            case -1:
              if (this.props.direction === -1) {
                slideClasses.push(animationType + 'animated-prev');
              }
              break;
            default:
              break;
          }
        }

        var opacity = isSwipeVersion || isCurrent ? 1 : 0;

        if (_utils.utils.browserIs('safari') && !_utils.utils.isMobile()) {
          (0, _assign2.default)(innerStyle, {
            opacity: opacity,
            transform: 'none',
            WebkitTransform: 'none',
            MozTransform: 'none',
            msTransform: 'none',
            OTransform: 'none'
          });
        } else {
          (0, _assign2.default)(innerStyle, {
            opacity: opacity,
            willChange: 'transform'
          });
        }

        slides.push(itm && itm.idx >= 0 ? _react2.default.createElement(
          'div',
          {
            key: 'swipe-item-' + itm.idx,
            'data-index': itm.idx,
            className: slideClasses.join(' '),
            style: innerStyle,
            'data-hook': isCurrent ? 'fullscreen-current' : 'fullscreen-away'
          },
          this.prepareSlide(itm),
          this.props.isMobileZoom ? null : this.prepareInfo(itm)
        ) : _react2.default.createElement('div', {
          key: 'swipe-item-placeholder-' + slidePos,
          className: slideClasses.join(' '),
          style: innerStyle
        }));
      }

      return slides;
    }
  }, {
    key: 'getLeftArrowSvg',
    value: function getLeftArrowSvg() {
      return _react2.default.createElement(
        'svg',
        {
          xmlns: 'http://www.w3.org/2000/svg',
          fill: 'currentColor',
          stroke: 'none',
          width: '15',
          height: '27',
          viewBox: '0 0 15 27'
        },
        _react2.default.createElement(
          'g',
          { fillRule: 'evenodd' },
          _react2.default.createElement('path', {
            fillRule: 'nonzero',
            d: 'M14.258 1.53L13.198.47-.061 13.728l13.259 13.258 1.06-1.06L2.061 13.728z'
          })
        )
      );
    }
  }, {
    key: 'getRightArrowSvg',
    value: function getRightArrowSvg() {
      return _react2.default.createElement(
        'svg',
        {
          fill: 'currentColor',
          stroke: 'none',
          width: '15',
          height: '27',
          viewBox: '0 0 15 27'
        },
        _react2.default.createElement(
          'g',
          { fillRule: 'evenodd' },
          _react2.default.createElement('path', {
            fillRule: 'nonzero',
            d: 'M.198 25.926l1.06 1.06 13.259-13.258L1.258.47.198 1.53l12.197 12.198z'
          })
        )
      );
    }
  }, {
    key: 'createDummyItemForFirstFocus',
    value: function createDummyItemForFirstFocus(leftArrowLeftPos) {
      var _this2 = this;

      //this element is created to receive the initial focus when fullscreen (or expand mode) are opened, before any 'tab' is pressed.
      return _react2.default.createElement('div', {
        className: 'pro-fullscreen-accessibility-dummy',
        tabIndex: 0,
        ref: function ref(_ref) {
          return _this2.dummyAccessibilityItem = _ref;
        },
        style: {
          position: 'absolute',
          height: '1px',
          width: '1px',
          left: leftArrowLeftPos
        } });
    }
  }, {
    key: 'createNavArrows',
    value: function createNavArrows(leftArrowLeftPos, rightArrowLeftPos) {
      var _this3 = this;

      var loop = this.props.styleParams.fullscreenLoop;
      return [_react2.default.createElement(
        'button',
        {
          className: 'pro-fullscreen-arrow has-custom-focus arrow-left fullscreen-icon' + (this.props.isExpandedView ? ' expanded' : '') + (this.props.current.idx <= 0 ? ' fullscreen-icon-disabled ' : ''),
          onClick: function onClick() {
            return _this3.props.actions.fadeToNextSlide(-1);
          },
          ref: function ref(_ref2) {
            return _this3.leftArrowElement = _ref2;
          },
          tabIndex: this.props.current.idx <= 0 ? -1 : 0,
          'aria-label': 'Previous Item',
          style: {
            position: 'absolute',
            left: leftArrowLeftPos
          }
        },
        this.getLeftArrowSvg()
      ), _react2.default.createElement(
        'button',
        {
          className: 'pro-fullscreen-arrow has-custom-focus arrow-right fullscreen-icon' + (this.props.isExpandedView ? ' expanded' : '') + (this.props.current.idx >= this.props.totalItems - 1 && !loop ? ' fullscreen-icon-disabled ' : ''),
          onClick: function onClick() {
            return _this3.props.actions.fadeToNextSlide(1);
          },
          ref: function ref(_ref3) {
            return _this3.rightArrowElement = _ref3;
          },
          tabIndex: this.props.current.idx >= this.props.totalItems - 1 ? -1 : 0,
          'aria-label': 'Next Item',
          style: {
            position: 'absolute',
            left: rightArrowLeftPos
          } },
        this.getRightArrowSvg()
      )];
    }
  }, {
    key: 'render',
    value: function render() {
      var firstSlidePosition = this.props.current.pos * this.getSlideWidth(true) + this.marginWidth;
      var shouldShowStoreArrows = _fullscreen.fullscreenVersionManager.useFullscreenNewSlider() && !_utils.utils.isSmallScreen();
      var leftArrowLeftPos = firstSlidePosition + (this.props.window.expanded && _fullscreen.fullscreenVersionManager.useFullscreenNewSlider() ? 10 : 0);
      var rightArrowLeftPos = firstSlidePosition + (this.getSlideWidth(true) - (this.props.window.expanded && _fullscreen.fullscreenVersionManager.useFullscreenNewSlider() ? 110 : 100));
      var swipeWrapStyle = {
        width: (this.props.current.pos * 2 + 1) * this.getSlideWidth(false),
        marginLeft: -1 * firstSlidePosition,
        willChange: 'transform'
      };

      if (this.props.isLandscape) {
        swipeWrapStyle.height = this.props.window.size.height;
      }

      return _react2.default.createElement(
        'div',
        {
          id: 'slider',
          className: 'pro-fullscreen-swipe ' + (_utils.utils.isMobile() && _fullscreen.fullscreenVersionManager.useFullscreenNewSlider() ? this.props.isMobileZoom ? 'pro-fullscreen-zoom' : 'pro-fullscreen-scroll' : ''),
          style: {
            marginLeft: this.marginWidth + 'px',
            marginRight: this.marginWidth + 'px'
          }
        },
        _react2.default.createElement(
          'div',
          {
            className: 'pro-fullscreen-swipe-wrap pro-fullscreen-before-swipe swipe-wrap-idx-' + this.props.current.idx,
            key: 'swipe-wrap',
            style: swipeWrapStyle
          },
          shouldShowStoreArrows && _utils.utils.isAccessibilityEnabled() ? this.createDummyItemForFirstFocus(leftArrowLeftPos) : null,
          shouldShowStoreArrows ? this.createNavArrows(leftArrowLeftPos, rightArrowLeftPos) : '',
          this.prepareSlides()
        )
      );
    }
  }]);
  return FullscreenSlider;
}(_react2.default.Component);

exports.default = FullscreenSlider;